const digest = '4f3d875ec666c003e6a76ce352902e800bdc39d5b233adfe1b4adcca15d76ff5';
const css = `._loaderContainer_dtu8r_1{min-height:55rem}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'loaderContainer': '_loaderContainer_dtu8r_1' };
export const loaderContainer = '_loaderContainer_dtu8r_1';
export { css, digest };